import { toast } from 'react-toastify';

export const apiError = (error: any) => {
  if (error.toString().startsWith('TypeError: Failed to fetch')) {
    toast.error('An error occurred while fetching data.');
  } else if (Array.isArray((error as any)?.error?.detail)) {
    (error as any)?.error?.detail.forEach((el: any) =>
      toast.error(el.msg, { autoClose: false, hideProgressBar: true }),
    );
  } else {
    toast.error((error as any).error.detail, { autoClose: false, hideProgressBar: true });
  }
};
